module.exports = __webpack_public_path__ + "img/thumb.d67b21bd.png";